// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

async function loadComponentsIfNeeded() {
  const tasks = [];
  if (document.querySelector("quiz-app")) {
    tasks.push(import("./components/quiz-app"));
  }
  if (document.querySelector("learn-app")) {
    tasks.push(import("./components/learn-app"));
  }
  if (document.querySelector("exam-app")) {
    tasks.push(import("./components/exam-app"));
  }
  if (tasks.length) await Promise.all(tasks);
}

document.addEventListener("DOMContentLoaded", loadComponentsIfNeeded)
document.addEventListener("turbo:load", loadComponentsIfNeeded)
